import { fieldMixin, formErrorMixin } from "../../../mixins";

export default {
  mixins: [fieldMixin, formErrorMixin],

  props: {
    component: {
      required: true,
      type: String,
      default: false
    }
  },

  data() {
    return {
      localValue: this.value
    };
  },

  render(h) {
    const t = this;
    return h(
      t.component,
      Object.assign({
        props: {
          value: t.localValue
        },
        on: {
          input: t.handleOnChange
        }
      })
    );
  },

  watch: {
    value(newVal, oldVal) {
      this.localValue = newVal;
    },

    localValue(newVal, oldVal) {
      this.clearError();
      this.$emit("input", this.localValue);
    }
  },

  methods: {
    handleOnChange(value) {
      this.$emit("input", value);
    }
  }
};
